import { useEffect, useState } from "react";

//hooks
import { useHaltPropagation } from "@/components/hooks/utility/useHaltPropagation";
import { getCommentArchivalBannerMessage } from "@/helpers/ActivityFeed";

//interfaces
import {  ActionFeedback } from "thrive-components";
import { IUseCommentPost } from "@/interfaces/activityFeedNotifications";


const UseCommentPost = ({activityId, isPopOut, timeStamp, meta, parentList, comment, content, appDetails, onLikeClick, onPostCommentClick, onDeleteCommentClick, notificationDetails}: IUseCommentPost) => {
    const [showCommentFunctionality, setShowCommentFunctionality] = useState<boolean>(false);
    const [commentString, setCommentString] = useState<string>("");
    const [showDeleteFunctionality, setShowDeleteFunctionality] = useState<boolean>(false);
    const [isPosting, setIsPosting] = useState<boolean>(false);
    const screenClassName = isPopOut ? "" : "full-screen-styling";
    const showDeletedBanner = content.isArchived || comment.isDeleted;
    const deletedBannerMessage = getCommentArchivalBannerMessage(content?.isArchived);
    const deletedCommentClassName = comment.isDeleted ? "deleted-comment" : "";
    const showFeedbackBanner : boolean = !!notificationDetails;
    const feedbackType = notificationDetails?.isSuccess ? ActionFeedback.SUCCESS : ActionFeedback.ERROR;
    const feedbackMessage = notificationDetails?.message ?? '';
    const truncation = isPopOut ? 100 : 228
    const isLiked = meta.hasLiked ?? false;
    const hideMenu = content.isArchived;
    const activityInformation = {
        className:screenClassName,
        time:isPopOut ? timeStamp : undefined,
        appImageUrl: appDetails.isMultipleAppOrganisation ? appDetails.iconUrl : "", 
        appName: appDetails.isMultipleAppOrganisation ? appDetails.name : "",
        contentTitle: parentList?.title,
        contentLink: parentList?.link,
        likesEnabled: meta.likesEnabled, 
        commentsEnabled: meta.commentsEnabled,
        likes: meta.likeCount ?? 0,
        comments: meta.commentCount ?? 0,
        isReply: true,
        contentExistsInMultiplePlaces: content.existsInMultiplePlaces,
    }

    const allowCommentFunctionlity = !comment.isDeleted && meta.commentsEnabled 
    const allowLikeFunctionality = !comment.isDeleted && meta.likesEnabled;
    const handleReplyClick = allowCommentFunctionlity ? onMenuReplyClick : undefined;
    const handleDeleteClick = allowCommentFunctionlity ? onShowDeleteFunctionalityClick : undefined;
    const handleLikeClick = allowLikeFunctionality ? onLikeClick : undefined;

    useEffect(() => {
        setIsPosting(false);
    }, [notificationDetails?.message]);

    function onMenuReplyClick() {
        setShowCommentFunctionality(true);
    }

    function onShowDeleteFunctionalityClick(e?: any) {
        useHaltPropagation(e);
        if (!showCommentFunctionality) {
            setShowDeleteFunctionality(true);
        }
    };
    
    function onHideDeleteFunctionality(e?: any){
        useHaltPropagation(e);
        setShowDeleteFunctionality(false);
    }

    function onCommentClick() {
        setIsPosting(true);
        onPostCommentClick && onPostCommentClick(activityId, content.id, comment.id, commentString, appDetails.id);
        setShowCommentFunctionality(false);
        setCommentString("");
    }
    
    function onDelete(e?: any) {
        useHaltPropagation(e);
        setShowCommentFunctionality(false);
        onDeleteCommentClick && onDeleteCommentClick(activityId, appDetails.id, content.id, comment.id);
        setShowDeleteFunctionality(false);
    }

    return { screenClassName, deletedCommentClassName, showDeletedBanner, deletedBannerMessage, truncation, handleLikeClick, isLiked, handleReplyClick, handleDeleteClick, hideMenu, commentString,             setCommentString, onCommentClick, showCommentFunctionality, setShowCommentFunctionality, showFeedbackBanner, feedbackType, feedbackMessage, showDeleteFunctionality, onHideDeleteFunctionality, onDelete, activityInformation, isPosting}
};

export default UseCommentPost